import { render, staticRenderFns } from "./ReminderRuleList.vue?vue&type=template&id=b64ab66c&scoped=true&"
import script from "./ReminderRuleList.vue?vue&type=script&lang=js&"
export * from "./ReminderRuleList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderRuleList.vue?vue&type=style&index=0&id=b64ab66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64ab66c",
  null
  
)

export default component.exports